import React from 'react';
import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import XIcon from 'svg/XIcon';

type Props = {
  children: React.ReactNode;
  // Spread onto the remove button, so a select can pass react-select's handlers whole.
  removeProps: React.ButtonHTMLAttributes<HTMLButtonElement>;
  // react-select's highlight on the chip Backspace will remove next.
  focused?: boolean;
  disabled?: boolean;
  className?: string;
};

export default function DismissibleChip({
  children,
  removeProps,
  focused = false,
  disabled = false,
  className,
}: Props) {
  return (
    <Chip className={className}>
      <Label $disabled={disabled}>{children}</Label>
      {!disabled && (
        <RemoveButton type='button' $focused={focused} {...removeProps}>
          <XIcon width={8} height={8} />
        </RemoveButton>
      )}
    </Chip>
  );
}

const Chip = styled.div`
  display: flex;
  min-width: 0;
  border-radius: 3px;
  background: ${colors.black10};
`;

const Label = styled.div<{ $disabled: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: ${({ $disabled }) => ($disabled ? '3px 6px' : '3px 0 3px 6px')};
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black100};
`;

const RemoveButton = styled.button<{ $focused: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 8px;
  border: none;
  border-radius: 2px;
  background: ${({ $focused }) => ($focused ? colors.red10 : 'transparent')};
  color: ${colors.black100};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${colors.red10};
    color: ${colors.red100};
  }
`;

export const DismissibleChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
